export const REQUEST = 'autoBuild/REQUEST';
export const FAILURE = 'autoBuild/FAILURE';

export const GET_SKETCHES_SUCCESS = 'autoBuild/GET_SKETCHES_SUCCESS';
export const GET_SKETCH_DETAILS_SUCCESS = 'autoBuild/GET_SKETCH_DETAILS_SUCCESS';

export const GET_TEMPLATES_SUCCESS = 'autoBuild/GET_TEMPLATES_SUCCESS';
